<template>
  <div class="container-wrapper">
    <portfolioReq :initial-aggregation-mode="aggregationMode" :initial-aggregation-options="aggregationOptions" @request="handleRequest" @aggregationChange="handleAggregationChange"/>
    <evolCustomMetrics :aggregated-data="aggregatedData" :raw-data="rawData" :aggregation-mode="aggregationMode" :aggregation-options="aggregationOptions" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import portfolioReq from '@/forms/portfolioReq.vue';
import evolCustomMetrics from '@/components/evolCustomMetrics.vue';
import { aggregateLogs } from '@/utils/aggregateLogs.js';

export default {
  name: 'portfolioAnalysis',
  components: { portfolioReq, evolCustomMetrics },
  data() {
    return {
      rawData: [],
      aggregationMode: 'time',
      aggregationOptions: {},
      loading: false,
      error: null,
    };
  },
  computed: {
    ...mapState(['socket']),
    aggregatedData() {
      return aggregateLogs(this.rawData, { ...this.aggregationOptions, mode: this.aggregationMode });
    }
  },
  mounted() {
    this.wsHandler = (event) => {
      let msg;

      try {
        msg = JSON.parse(event.data);
      } catch (error) {
        return;
      }
      if (msg.type === 'userReq_getLogsPeriod') {
        this.rawData = Array.isArray(msg.data) ? msg.data : (msg.data?.allLogs || []);
      }
    };

    this.unwatchSocket = this.$watch(
      () => this.socket,
      (newWs, oldWs) => {
        if (oldWs && this.wsHandler) {
          oldWs.removeEventListener('message', this.wsHandler);
        }

        if (newWs && this.wsHandler) {
          newWs.addEventListener('message', this.wsHandler);
        }
      },
      { immediate: true }
    );
  },
  beforeUnmount() {
    if (this.unwatchSocket) {
      this.unwatchSocket();
    }

    if (this.socket && this.wsHandler) {
      this.socket.removeEventListener('message', this.wsHandler);
    }
  },
  methods: {
    async handleRequest(payload) {
      this.loading = true;
      this.error = null;
      this.aggregationMode = payload.aggregationMode;
      this.aggregationOptions = payload.aggregationOptions;

      try {
        const req = {
          type: 'getLogsPeriod',
          startDate: payload.startDate,
          endDate: payload.endDate,
        };

        if (this.socket) {
          this.socket.send(JSON.stringify(req));
        }
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    },
    handleAggregationChange({ aggregationMode, aggregationOptions }) {
      console.log('Aggregation change received:', aggregationMode, aggregationOptions);
      this.aggregationMode = aggregationMode;
      this.aggregationOptions = aggregationOptions;
    }
  }
};
</script>
